<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Aguarde ...</p>
</ngx-spinner>
<div class="row">
    <div class="col-12">
        <app-card cardTitle="Cadastro de Documento" blockClass="table-border-style" [options]="false">
            <div class="row">
                <div class="col-sm-6 col-xl-4">
                    <label class="sub-title">Tipo de  Documento</label>
                    <input type="text" class="form-control" name="appFacebook" placeholder="">
                </div>
                <div class="col-sm-6 col-xl-4">
                    <label class="sub-title">Etapa</label>
                    <select class="form-control">
                        <option>Documentos</option>
                        <option>Checklist</option>
                        <option>Videos</option>
                        <option>POP</option>                
                    </select>
                </div>
               <!-- <div class="col-sm-6 col-xl-4">
                    <label class="sub-title">Data Expiração</label>
                    <input type="date" class="form-control" name="token" placeholder="">
                </div>  -->              
                <div class="col-sm-6 col-xl-12">
                    <label class="sub-title">Observação</label>                   
                    <textarea name="" id="" class="form-control" ></textarea>
                </div>
                
            </div>
            <br> <br>


            <br> <br>
            <div class="row">
                <div class="col-sm-12 ">
                    <button type="button" class="btn btn-warning float-left " (click)="voltar()">
                        <i class="feather icon-arrow-left mr-2 f-18"></i>
                        Voltar
                    </button>
                    <button type="button" class="btn btn-primary float-right " (click)="salvar()">
                        <i class="feather icon-check-circle mr-2 f-18"></i>
                        Salvar
                    </button>
                </div>
            </div>


        </app-card>
    </div>
</div>


<div class="row">
    <div class="col-12">
        <app-card cardTitle="Documentos a serem cadastrados" blockClass="table-border-style" [options]="false">
            <div class="row">
                <div class="col-md-6 col-sm-6">
                    <label for="exampleInputEmail1">Filtro</label>
                    <input type="text" class="form-control" [(ngModel)]="query"
                        placeholder="Digite seu filtro, sera feito uma busca em todas as colunas">
                </div>   
            </div>
            <br>
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>Tipo</th>
                           
                            <th>Etapa</th>
                            <th>Observação</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of arrayTriagem  | fullTextSearch:query">
                            <td>{{item.Tipo }}</td>
                        
                            <td>{{item.Etapa }}</td>
                            <td>{{item.Observacao }}</td>
                            <td> 
                                <button type="button" class="btn btn-icon btn-danger " >
                                    <i class="fa fa-trash"></i>
                                  </button>
                            </td>

                        </tr>
                    </tbody>
                </table>
            </div>
        </app-card>
    </div>
</div>